import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import JacketFan from "../images/libya-2019-fan.png"
import { Link } from "react-router-dom"
import GoTrue from "gotrue-js"
import { connect } from "react-redux"
import SmallCloseIcon from "../images/small-close.svg"
import { saveUser } from "../actions/index"
import Modal from "react-modal"
import CloseIcon from "../images/close.svg"

const auth = new GoTrue({
  APIUrl: "https://www.englishforlibya.com/.netlify/identity",
  audience: "",
  setCookie: true,
})

class Home extends React.Component {
  state = {
    confirmSuccess: "",
    confirmError: "",
    passwordResetModalOpen: false,
    password: "",
    passwordUpdateSuccess: "",
    passwordUpdateError: "",
  }

  // manages input of password in reset password modal
  passwordInput = (event) => {
    this.setState({ password: event.target.value })
  }

  // updates password on Go-True
  updatePassword = (event) => {
    event.preventDefault()

    const user = auth.currentUser()
    console.log(user)

    user
      .update({ password: this.state.password })
      .then((response) => this.setState({ passwordUpdateSuccess: true }))
      .then((response) => this.setState({ passwordResetModalOpen: false }))
      .catch((error) => {
        this.setState({
          passwordUpdateError: "Something has gone wrong - please try again",
        })
      })
  }

  // required for screen readers
  componentWillMount() {
    Modal.setAppElement("body")
  }

  componentDidMount() {
    if (this.props.location.hash) {
      const hash = this.props.location.hash
      console.log(hash)

      // check whether confirmation_token or recovery_token

      // extract first two characters from hash to identify type
      const shortHash = hash.slice(0, 2)

      if (shortHash === "#r") {
        // find everything in hash after '=' symbol
        const token = hash.split("=")[1]

        // use GoTrue recover method to log user in and update localstorage and state
        auth
          .recover(token)
          .then((response) => this.props.saveUser(response))
          // .then(response => console.log(auth.currentUser()))
          .then((response) =>
            console.log("Logged in as %s", JSON.stringify({ response }))
          )
          .catch((error) =>
            console.log("Failed to verify recover token: %o", error)
          )

        // user now logged in. Open modal so that they can add new password
        this.setState({
          passwordResetModalOpen: true,
        })
      } else if (shortHash === "#c") {
        const token = hash.slice(20)

        auth
          .confirm(token)
          //.then(response => console.log('The process has worked successfully' + response))
          //.then(response => this.props.saveUser(response))
          //.then(response => console.log(response))
          .then((response) =>
            this.setState({
              confirmSuccess: true,
            })
          )
          .catch((error) =>
            this.setState({
              confirmError: true,
            })
          )
      }
    }
  }

  render() {
    return (
      <div>
        <div className="hero-image">
          <Header />
        </div>

        {this.state.confirmSuccess === true ? (
          <p
            className="auth-success"
            style={{
              position: "absolute",
              top: 5,
              left: 10,
              right: 10,
              textAlign: "center",
              marginTop: 0,
            }}
          >
            You have successfully confirmed your email address. Please now log
            in.
            <span style={{ float: "right", paddingRight: 20 }}>
              <img
                alt=""
                className="confirm-message-close"
                src={SmallCloseIcon}
                onClick={(event) => this.setState({ confirmSuccess: "" })}
              />
            </span>
          </p>
        ) : (
          <p></p>
        )}

        {this.state.confirmError === true ? (
          <p
            className="auth-error"
            style={{
              position: "absolute",
              top: 5,
              left: 10,
              right: 10,
              textAlign: "center",
              marginTop: 0,
            }}
          >
            Unfortunately something has gone wrong confirming your email
            address. Please try again.
            <span style={{ float: "right", paddingRight: 20 }}>
              <img
                alt=""
                className="confirm-message-close"
                src={CloseIcon}
                onClick={(event) => this.setState({ confirmError: "" })}
              />
            </span>
          </p>
        ) : (
          <p></p>
        )}

        {this.state.passwordUpdateSuccess === true ? (
          <p
            className="auth-success"
            style={{
              position: "absolute",
              top: 5,
              left: 10,
              right: 10,
              textAlign: "center",
              marginTop: 0,
            }}
          >
            You have successfully updated your password
            <span style={{ float: "right", paddingRight: 20 }}>
              <img
                alt=""
                className="confirm-message-close"
                src={SmallCloseIcon}
                onClick={(event) =>
                  this.setState({ passwordUpdateSuccess: "" })
                }
              />
            </span>
          </p>
        ) : (
          <p></p>
        )}

        <div className="opening-section container">
          <div style={{ marginTop: "0px" }} className="opening-section-child-1">
            <h1 className="primary-header">English for Libya</h1>
            <p>
              <i>21st Century English for Libya</i> is a modern, engaging
              course, which integrates a general English syllabus with 21st
              century skills, including study skills, teamwork, critical
              thinking and problem solving – the essential skills for students
              of English to thrive in the 21st century.
            </p>
            <p>
              This website provides professional development resources,
              including training manuals, presentations, handouts and videos,
              plus classroom resources for teachers, including the complete
              teacher books and audio files. You can also use the forum to
              interact with your peers and ask questions.
            </p>
          </div>
          <div className="opening-section-child-2">
            <img
              className="responsive-image"
              style={{ paddingLeft: "10px" }}
              alt=""
              src={JacketFan}
            />
            {/*<Img style={{paddingLeft: '10px'}} sizes={this.props.data.jacketImage.sizes} />*/}
          </div>
        </div>

        <div
          style={{ backgroundColor: "#F5F4F3" }}
          className="home-button-wrapper"
        >
          <div className="container home-button-container">
            <Link
              style={{ textDecoration: "none" }}
              to="professional-development"
            >
              <div className="cpd home-button">
                <div className="home-button-text-wrapper">
                  <p>Professional Development</p>
                </div>
              </div>
            </Link>

            <Link style={{ textDecoration: "none" }} to="resources">
              <div className="resources home-button">
                <div className="home-button-text-wrapper">
                  <p>Teaching Resources</p>
                </div>
              </div>
            </Link>

            <Link to="forum" style={{ textDecoration: "none" }}>
              <div className="forum home-button">
                <div className="home-button-text-wrapper">
                  <p>Share your views and feedback</p>
                </div>
              </div>
            </Link>
          </div>
        </div>

        <Modal isOpen={this.state.passwordResetModalOpen} contentLabel="Modal">
          <img
            alt=""
            src={CloseIcon}
            style={{ float: "right", width: 40 }}
            onClick={() => this.setState({ passwordResetModalOpen: false })}
          />

          <div style={{ textAlign: "center", marginTop: 100 }}>
            <h2 style={{ marginTop: 20, color: "#816992" }}>
              Set new password
            </h2>
            <form onSubmit={this.updatePassword}>
              <label>New password</label>
              <input
                placeholder="New password"
                type="password"
                value={this.state.password}
                onChange={this.passwordInput}
              ></input>
              <br />

              <input
                style={{ marginTop: 20 }}
                className="purple-button"
                type="submit"
                value="Submit"
              />
            </form>

            {/* error message is shown at bottom of modal. Success message is shown at top of screen after modal closes */}

            {this.state.passwordUpdateError.length ? (
              <p style={{ textAlign: "center" }} className="auth-error">
                {this.state.passwordUpdateError}
              </p>
            ) : (
              <p></p>
            )}
          </div>
        </Modal>

        <Footer />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    location: state.router.location,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user) => dispatch(saveUser(user)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)



// WEBPACK FOOTER //
// ./src/components/Home.js